import React from 'react';

const ImageRender = props => {
  const {
    icon
  } = props;
  return /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: "Logo"
  });
};

export default ImageRender;